import { capitalize, cn } from 'utils'

type Period = 'monthly' | 'annual'

type PeriodToggleProps = {
  period: Period
  onChange: (period: Period) => void
}

type PeriodItemProps = {
  period: Period
  isSelected: boolean
  onClick: () => void
}

function PeriodItem ({ period, isSelected, onClick }: PeriodItemProps) {
  return (
    <button
      className={cn('flex-1 px-4 py-2 rounded-lg text-sm', {
        'border border-thatch-500 bg-thatch-100 font-semibold': isSelected,
        'hover:bg-gray-50': !isSelected,
      })}
      onClick={onClick}
    >
      {capitalize(period)}
    </button>
  )
}

function PeriodToggle ({ period, onChange }: PeriodToggleProps) {
  return (
    <div className='flex border border-gray-200 rounded-lg p-0.5'>
      <PeriodItem period='monthly' isSelected={period === 'monthly'} onClick={() => onChange('monthly')} />
      <PeriodItem period='annual' isSelected={period === 'annual'} onClick={() => onChange('annual')} />
    </div>
  )
}

export default PeriodToggle
